module.exports = __webpack_public_path__ + "img/about-m-slide-25.5662ebe6.jpg";